module.exports = __webpack_public_path__ + "media/images/countryrect/sk-2234bc1101d7adad49811b5989f76291.svg";